import * as React from 'react';
import { Box, Button, TextField, Typography } from '@material-ui/core';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uploadFileAsync } from '../../TeenybeansPortal/TeenybeansSchools/bccTeenybeansStore/bccTeenybeansStoreSlice';
import { getSeo, postSeo } from './ManagementStore/managementStoreSlice';

const SeoData = ({ id, handleClose }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [schema1, setSchema1] = useState('');
  const [schema2, setSchema2] = useState('');
  const [schema3, setSchema3] = useState('');
  const [ogImg, setOgImg] = useState('');
  const [show, setShow] = useState(true);
  const dispatch = useDispatch();

  const { metaData } = useSelector(({ approvalManagementReducer }) => {
    return {
      metaData:
        approvalManagementReducer &&
        approvalManagementReducer.metadata &&
        approvalManagementReducer.metadata.scripts,
    };
  });

  const handleUploadDocument = (e) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(uploadFileAsync({ file: e.target.files[0] }))
        .unwrap()
        .then((res) => {
          setOgImg(res && res.data && res.data.document);
        });
    }
  };

  const handleCreateLead = () => {
    dispatch(
      postSeo({
        params: id,
        data: {
          scripts: {
            title: title,
            description: description,
            schema1: schema1,
            schema2: schema2,
            schema3: schema3,
            ogImg: ogImg,
          },
        },
      })
    )
      .unwrap()
      .then((res) => {
        toast.success('SEO added for this school');
        setShow(true);
        handleClose();
      })
      .catch((err) => toast.error('Something went wrong.'));
  };

  React.useEffect(() => {
    dispatch(getSeo({ params: id }));
  }, [id]);

  React.useEffect(() => {
    setTitle(metaData && metaData.title);
    setDescription(metaData && metaData.description);
    setSchema1(metaData && metaData.schema1);
    setSchema2(metaData && metaData.schema2);
    setSchema3(metaData && metaData.schema3);
    setOgImg(metaData && metaData.ogImg);
  }, [metaData]);

  React.useEffect(() => {
    setTitle('');
    setDescription('');
    setSchema1('');
    setSchema2('');
    setSchema3('');
    setOgImg('');
  }, []);

  return (
    <Box sx={{ overflow: 'scroll', height: 500 }}>
      <Typography>
        <h2 style={{ margin: 0 }}>SEO Data</h2>
      </Typography>
      <Box mt={1} />
      <TextField
        label="Meta Title"
        placeholder="Meta Title"
        variant="outlined"
        size="small"
        value={title}
        disabled={show}
        fullWidth
        onChange={(e) => setTitle(e.target.value)}
      />
      <Box mt={1} />
      <TextField
        label="Meta Description"
        placeholder="Meta Description"
        variant="outlined"
        size="small"
        value={description}
        disabled={show}
        fullWidth
        onChange={(e) => setDescription(e.target.value)}
      />
      <Box mt={1} />
      <TextField
        label="Schema 1"
        placeholder="Schema 1"
        variant="outlined"
        size="small"
        multiline
        minRows={4}
        value={schema1}
        disabled={show}
        fullWidth
        onChange={(e) => setSchema1(e.target.value)}
      />
      <Box mt={1} />
      <TextField
        label="Schema 2"
        placeholder="Schema 2"
        variant="outlined"
        size="small"
        multiline
        minRows={4}
        value={schema2}
        disabled={show}
        fullWidth
        onChange={(e) => setSchema2(e.target.value)}
      />
      <Box mt={1} />
      <TextField
        label="Schema 3"
        placeholder="Schema 3"
        variant="outlined"
        size="small"
        multiline
        minRows={4}
        value={schema3}
        disabled={show}
        fullWidth
        onChange={(e) => setSchema3(e.target.value)}
      />
      <Box mt={1} display={'flex'}>
        <input
          type="file"
          disabled={show}
          onChange={(e) => handleUploadDocument(e)}
        />
        <Box ml={'auto'}>
          <Button onClick={handleClose} variant="outlined" color="primary">
            Cancel
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button
            onClick={() => {
              show === true ? setShow(false) : handleCreateLead();
            }}
            color="primary"
            disabled={
              show === true
                ? false
                : title === null ||
                  title === '' ||
                  description === null ||
                  description === '' ||
                  ogImg === null ||
                  ogImg === ''
            }
            variant="contained">
            {show === true ? 'Edit' : 'Submit'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SeoData;
